export default {
    API_URL: 'https://qs-api.sync360.io/',
    CLIENT_SECRET: '81YcfxOopAnGZFSV01C9T1v2KmiOtVBhvdYtycK1',
    GRANT_TYPE: 'password',
    CLIENT_ID: '2',
    PUSHER_APP_KEY: '66824d8739c0181af28e',
    PUSHER_APP_CLUSTER: 'mt1',
    UPLOAD_LIMIT: 5,
};
